require('./accountIntervenerRemoveError.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { OKLink } = require('commonsComponents/OKLink');
// @ helpers
const {FormattedText, formatText} = require('core/i18n').i18n;
// @ components
const WizardError = require('components/commons/wizardError/wizardError');

class AccountIntervenerRemoveError extends React.Component {

    componentWillUnmount() {
        this.props.clearIntervenerRemoval();
    }

    render() {
        const { immAccount, immIntervener } = this.props;
        const exitLink = `/myprofile/accounts/${immAccount.get('accountId')}/details`;
        const title = formatText('accountInterveners-errorMessage');
        const injectedStrings = [
            immIntervener.get('name')
        ];
        //With the following line we can access the error message from server response
        //const errorMessage = immAccountIntervenerRemoval.get('error');

        return (
            <WizardError
                errorMessage={title}
            >
                <div className="account-intervener-remove-error__content">
                    <FormattedText
                        value="accountInterveners-additionalErrorMessage"
                        injectedStrings={injectedStrings}
                    />
                    <footer className="account-intervener-remove-error__footer">
                        <OKLink modifier="emphasize" to={exitLink}>
                            <FormattedText value="accountInterveners-goBack" />
                        </OKLink>
                    </footer>
                </div>
            </WizardError>
        );
    }
}

AccountIntervenerRemoveError.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immIntervener: PropTypes.object.isRequired,
    immAccountIntervenerRemoval: PropTypes.object.isRequired,
    clearIntervenerRemoval: PropTypes.func.isRequired
};

module.exports = AccountIntervenerRemoveError;
